const itemsOnPage = [10, 25, 50, 100].map(item => ({
  key: item,
  value: item,
  renderElement: item,
  selectedRenderElement: item,
  active: item === 10,
}));

export { itemsOnPage };
